/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Separator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Separator({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/ResponsibleRelatives/Content/ResponsibleRelative/Separator"
  
}) {
let responsibleRelativeItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'responsible_relative_item',
path: 'isLast',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={responsibleRelativeItemIsLastValueData ? "" : ","}
 marginRight={responsibleRelativeItemIsLastValueData ? "0px" : dtSpaceXxs}
 marginLeft={responsibleRelativeItemIsLastValueData ? "0px" : dtSpaceXxs}
 data="responsible_relative_item.isLast"
/>
{children}
</React.Fragment>)
}